import { Outlet } from 'react-router-dom';
import PublicHeader from '@/components/PublicHeader';
import PublicFooter from '@/components/PublicFooter';
import PointerCursor from '@/components/ds/PointerCursor';
import { SupportProvider } from '@/contexts/SupportContext';

const PublicLayout = () => {
  return (
    <SupportProvider>
      <div className="flex min-h-screen flex-col overflow-x-hidden bg-background">
        <div className="ds-grain" aria-hidden="true" />
        <PointerCursor />
        <PublicHeader />
        <main id="main-content" tabIndex={-1} className="flex-1 focus:outline-none">
          <Outlet />
        </main>
        <PublicFooter />
      </div>
    </SupportProvider>

  );
};

export default PublicLayout;
